const rules = [
  ["Tacos", /\b(taco|tacos|taquer|birria|árabe|arabe)\b/i],
  ["Burgers", /\b(burger|hamburgues|fast food)\b/i],
  ["Desayunos", /\b(desayuno|brunch|chilaquil|huevo|hot ?cake)\b/i],
  ["Café", /\b(café|cafe|coffee|panader|repost|postre)\b/i],
  ["Mexicana", /\b(mexican|poblana|cemita|antojito|torta|mole|chalupa)\b/i],
  ["Pizza", /\b(pizza|pizzer)\b/i],
  ["Mariscos", /\b(marisco|ceviche|pescado|camar[oó]n)\b/i],
  ["Asiática", /\b(sushi|ramen|japon|corean|thai|china|asi[aá]tic)\b/i],
];

export const inferPlaceCategory = (...parts) => {
  const text = parts.filter(Boolean).join(" ");
  const match = rules.find(([, regex]) => regex.test(text));
  return match ? match[0] : "";
};

export const inferCategoryWithOverride = ({ manual, name, type, notes }) => {
  const chosen = String(manual || "").trim();
  return chosen || inferPlaceCategory(name, type, notes);
};
